import React from 'react'
import Nav from './Nav'

function Payment() {
  return (
    <>
      <Nav />
    </>
  )
}

export default Payment
